import { cva, VariantProps } from "class-variance-authority";
export { default as PaymentHeader } from './PaymentHeader.vue';
export { default as PaymentStepper } from './PaymentStepper.vue';
export { default as PaymentTitle } from './PaymentTitle.vue';

export const paymentHeaderVariants = cva('py-6 px-4 rounded-2xl', {
  variants: {
    variant: {
      'paid': 'bg-white',
      'pending': 'bg-blue-50',
      'waiting': 'bg-blue-50',
      'canceled': '',
      'refunded': '',
      'released': 'bg-yellow-50',
      'canceled_by_admin': 'bg-red-50',
    },

  },
  defaultVariants: {
    variant: 'pending'
  }
})


export type PaymentHeaderVariants = VariantProps<typeof paymentHeaderVariants>

export const paymentTitleHeader = cva('text-2xl/none font-semibold font-inter gap-2', {
  variants: {
    variant: {
      'paid': 'text-green-600',
      'pending': 'text-blue-800',
      'waiting': 'text-blue-800',
      'canceled': '',
      'refunded': '',
      'released': 'bg-yellow-50',
      'canceled_by_admin': 'bg-red-50',
    }
  },
  defaultVariants: {
    variant: 'pending'
  }
})


export type PaymentTitleHeader = VariantProps<typeof paymentTitleHeader>

export const paymentStepperHeader = cva('', {
  variants: {
    variant: {
      'pending': 'bg-blue-50'
    }
  },
  defaultVariants: {
    variant: 'pending'
  }
})


export type PaymentStepperHeader = VariantProps<typeof paymentStepperHeader>
